import React, { Suspense } from 'react';
import { IPredictedLineupsHp } from '@sky-it-livedata/livedata-sports-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const MatchPredictedLineupsWrapper = React.lazy(() => import('./match-predicted-lineups'));
export interface IDynamicMatchPredictedLineupsWrapper extends IComponentModel<IPredictedLineupsHp> {
  live?: boolean;
  model: any;
}

const DynamicMatchPredictedLineups = ({
  /* istanbul ignore next: default value on mandatory field */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  live = false,
}: IDynamicMatchPredictedLineupsWrapper) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <MatchPredictedLineupsWrapper
      initialModel={validateModel(model) as IPredictedLineupsHp}
      query={validateModel(query)}
      live={live}
    />
  </Suspense>
);

DynamicMatchPredictedLineups.defaultProps = {
  live: false,
};

export default DynamicMatchPredictedLineups;
